import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const ApprovalTaxSummary = ({ info, taxbill }) => {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            계산서 발행일자
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            결재타입
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            작성일자
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            작성자
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            결재상태
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            최종승인일자
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {taxbill?.reqCompDt}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            {info?.docyTyp}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {info?.crtDt}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            {info?.crtNm}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            {info?.docuYn === 'S' && '진행중'}
            {info?.docuYn === 'Y' && '완료'}
            {info?.docuYn === 'N' && '거부'}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {info?.docuDt}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApprovalTaxSummary;
